<template>
  <div class="message-login-box">
    <dl class="show-flex-box-c">
      <dt class="user-acount">
        <input type="text" placeholder="账号" v-model="phoneNumber" autocomplete="off">
      </dt>
      <dd class="user-code">
        <sendAuthcode :phoneNum='phoneNumber' :codeType='"login"' @inputCode='getAuthCode'></sendAuthcode>
      </dd>
    </dl>
  </div>
</template>

<script>
import sendAuthcode from '@/components/common/send_authcode_cpn'                 //验证码

export default {
  name: 'message_login_cpn',
  data () {
    return {
      phoneNumber: '',
      authCode: ''         //验证码
    }
  },
  components: {
    sendAuthcode
  },
  methods: {
    getAuthCode: function(code) {
      this.authCode = code;
      if (this.authCode) {
        this.postCurCode();
      }
    },
    postCurCode: function() {
      this.$emit('pass-code-params',this.authCode);
    },
    postCurPhoneNum: function() {
      this.$emit('pass-phonenum-params',this.phoneNumber);
    },
  },
  watch: {
    authCode: function() {
      this.postCurCode();
    },
    phoneNumber: function() {
      this.postCurPhoneNum();
    }
  }
}
</script>

<style lang="less" scoped>
  .message-login-box{
    width: 100%;
    &>dl{
      width: 100%;
      &>dt{
        width: 100%;
        margin-bottom: 16px;
        &>input{
          width: 234px;
          height: 38px;
          padding-left: 14px;
          border: 1px solid #E5E5E5;
          background: #FAFAFA;
          color: #191D21;
          border-radius: 5px;
        }
      }
      &>dd{
        width: 100%;
        &>input{
          width: 234px;
          height: 38px;
          padding-left: 14px;
          border: 1px solid #E5E5E5;
          background: #FAFAFA;
          color: #191D21;
          border-radius: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/message_login_cpn.vue